export const DISABLE_BUSINESS_HOURS = 'reports/controls/DISABLE_BUSINESS_HOURS'
export const ENABLE_BUSINESS_HOURS = 'reports/controls/ENABLE_BUSINESS_HOURS'
export const TIMEFRAME_CHANGE = 'reports/controls/TIMEFRAME_CHANGE'
export const TOGGLE_BUSINESS_HOURS = 'reports/controls/TOGGLE_BUSINESS_HOURS'
export const HIDE_BUSINESS_HOURS_NOTICE =
  'reports/controls/HIDE_BUSINESS_HOURS_NOTICE'
